export class ServiceError extends Error {
    public code: string
    public description: string | null
    public status: number | null
    public details: any

    constructor(
        data: {
            message: string
            code: string
            description?: string
            details?: any
        },
        status?: number
    ) {
        super(data.message)
        this.name = "ServiceError"
        this.message = data.message
        this.code = data.code
        this.description = data.description ?? null
        this.status = status ?? null
        this.details = data.details
    }
}
